var prefix = "/authentication";
export var ApplicationPaths = {
    DefaultLoginRedirectPath: "/",
    AuthorizationPrefix: prefix,
    Login: prefix + "/login",
    Logout: prefix + "/logout"
};
